import axios from 'axios';
import config from '../config';

const API_BASE_URL = config.baseApi;

export const login = async (email, password) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/api/v1/admin/login`,
      {
        email,
        password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      console.log("LOGIN URL:", `${API_BASE_URL}/api/v1/admin/login`);
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

